import React__default from 'react';
import classNames from './../external_lib/classnames/index.js';

function CarouselProgressIndicator(_a) {
    var classes = _a.classes, slides = _a.slides, position = _a.position;
    return (React__default.createElement("div", { className: classNames('carousel-progress-indicator', classes) }, slides.map(function (_, index) { return (React__default.createElement("div", { className: classNames('carousel-progress__dot', {
            'carousel-progress__dot--active': index === position
        }), key: index })); })));
}

export { CarouselProgressIndicator as default };
//# sourceMappingURL=CarouselProgressIndicator.js.map
